import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, Popup, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { STP_CENTER } from "./routing";

const pin = (color, label) => L.divIcon({
  className: "",
  html: `<div style="background:${color};color:#fff;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35);border-radius:999px;width:34px;height:34px;display:grid;place-items:center;font:700 13px Inter,sans-serif">${label}</div>`,
  iconSize: [34, 34], iconAnchor: [17, 17],
});
export const ICONS = { dest: pin("#00532D", "B"), courier: pin("#E0A800", "O"), me: pin("#2563eb", "•") };

function Fit({ points, fitSingle }) {
  const map = useMap();
  useEffect(() => {
    const valid = points.filter(Boolean);
    if (valid.length > 1) map.fitBounds(valid.map((p) => [p.lat, p.lng]), { padding: [40, 40], maxZoom: 16, animate: false });
    else if (valid.length === 1 && fitSingle) map.setView([valid[0].lat, valid[0].lng], 15, { animate: false });
  }, [JSON.stringify(points)]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

function ClickHandler({ onClick }) {
  useMapEvents({ click: (e) => onClick?.({ lat: e.latlng.lat, lng: e.latlng.lng }) });
  return null;
}

export default function MapView({ markers = [], route, onClick, height = 320, testid = "map-view", fitSingle = true }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-100" style={{ height }} data-testid={testid}>
      <MapContainer center={[STP_CENTER.lat, STP_CENTER.lng]} zoom={12} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {markers.filter((m) => m.pos).map((m) => (
          <Marker key={m.key} position={[m.pos.lat, m.pos.lng]} icon={ICONS[m.icon] || ICONS.dest}>{m.label && <Popup>{m.label}</Popup>}</Marker>
        ))}
        {route && <Polyline positions={route.coords} pathOptions={{ color: route.road ? "#00532D" : "#B45309", weight: 5, dashArray: route.road ? null : "8 10" }} />}
        <Fit points={markers.map((m) => m.pos)} fitSingle={fitSingle} />
        <ClickHandler onClick={onClick} />
      </MapContainer>
    </div>
  );
}

export const RouteInfo = ({ route }) => !route ? null : (
  <p className="text-xs text-gray-600" data-testid="route-info">
    {route.road
      ? <>Percurso por estrada: <strong>{route.distanceKm.toFixed(1)} km</strong>{route.durationMin != null && <> · cerca de <strong>{Math.round(route.durationMin)} min</strong> (estimativa OSRM)</>}</>
      : <>Distância aproximada em linha reta: <strong>{route.distanceKm.toFixed(1)} km</strong> (percurso rodoviário indisponível)</>}
  </p>
);
